import { Typography } from "@mui/material";
import TimeService from "@services/timeService/timeService";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { Tooltip } from "@shared/Tooltip";

type DateCellProps = {
    value: string | null | undefined;
    width?: number;
    onClick?: () => void;
};

export const DateCell = (props: DateCellProps) => {
    if (!props.value) {
        return (
            <MinimalTableCell width={props.width} onClick={props.onClick}>
                <Typography>-</Typography>
            </MinimalTableCell>
        );
    }

    const displayDate = TimeService.getLocalDate(props.value, "ISO", "date");
    const fullDateTime = TimeService.getLocalDate(props.value, "ISO", "dateTime");

    return (
        <MinimalTableCell width={props.width} onClick={props.onClick}>
            <Tooltip title={fullDateTime}>
                <Typography>{displayDate}</Typography>
            </Tooltip>
        </MinimalTableCell>
    );
};
